import { render } from "./HPTIJ.vue?vue&type=template&id=18095504&scoped=true"
import script from "./HPTIJ.vue?vue&type=script&lang=js"
export * from "./HPTIJ.vue?vue&type=script&lang=js"

import "./HPTIJ.vue?vue&type=style&index=0&id=18095504&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18095504"]])

export default __exports__